"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.cssLinearGradientLength=(t=>Math.abs(Math.sin(t))+Math.abs(Math.cos(t))),exports.linearGradientStartAndEndPoints=((t,e,s)=>{const a=Math.sin(t)*e/2,n=Math.cos(t)*e/2;return{start:{x:s.x-a,y:1-(s.y-n)},end:{x:s.x+a,y:1-(s.y+n)}}});
//# sourceMappingURL=/@diez/framework-core/lib/linear-gradient.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@diez/framework-core/lib/linear-gradient.js
// module id = 412
// module chunks = 168707334958949